/**
 * Stripe web stub
 * This file replaces @stripe/stripe-react-native on web
 * The native SDK doesn't work on web - we use redirect checkout instead
 */

// Export empty StripeProvider that just renders children
export const StripeProvider = ({ children }: { children: React.ReactNode }) => children;

// Export empty useStripe hook
export const useStripe = () => ({
  initPaymentSheet: async () => ({ error: { message: 'Not available on web' } }),
  presentPaymentSheet: async () => ({ error: { message: 'Not available on web' } }),
});

// Export other commonly used items as no-ops
export const CardField = () => null;
export const CardForm = () => null;
export const ApplePayButton = () => null;
export const GooglePayButton = () => null;

export default {
  StripeProvider,
  useStripe,
};
